"use client";

import Script from "next/script";

const TTD_LOADER_SRC = "https://js.adsrvr.org/up_loader.3.0.0.js";

export default function CampaignTrackingFooterScripts() {
  return (
    <>
      <Script id="ttd-loader" src={TTD_LOADER_SRC} strategy="afterInteractive" />
      <Script id="ttd-universal-pixel" strategy="afterInteractive">
        {`
          window.ttdConversionEventsLayer = window.ttdConversionEventsLayer || [];
          function ttdConversionEvents() {
            window.ttdConversionEventsLayer.push(arguments);
          }
          ttdConversionEvents("init", {
            advertiserId: "1fpuw31",
            pixelIds: ["4xvw6nv"]
          });
          ttdConversionEvents("event", {
            advertiserId: "1fpuw31",
            pixelIds: ["4xvw6nv"]
          });
        `}
      </Script>
    </>
  );
}
